import { render, staticRenderFns } from "./Referencias.vue?vue&type=template&id=7fa958e4&scoped=true&lang=pug&"
import script from "./Referencias.vue?vue&type=script&lang=js&"
export * from "./Referencias.vue?vue&type=script&lang=js&"
import style0 from "./Referencias.vue?vue&type=style&index=0&id=7fa958e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa958e4",
  null
  
)

export default component.exports